import { MenuItem } from './menu-item.interface'; // adjust path as needed

export const PRACTICE_MENU_ITEMS: MenuItem[] = [
  { label: 'News Feeds', icon: 'newspaper', route: '/profile/my-dashboard', requiredPermission: 'news_feed_modules_permission' },
  { label: 'View Profile', icon: 'account_circle', route: '/profile/detail', exact: true },
  // { label: 'Favourites', icon: 'favorite', route: '/profile/favourites' },
  // { label: 'Directions', icon: 'pin_drop', route: '/profile/address' },
  { label: 'My Directory', icon: 'folder_open', route: '/profile/directory/listing', exact: true, requiredPermission: 'directory_minimal_permission' },
  { label: 'My Appointment', icon: 'access_time', route: '/profile/directory/appointment', exact: true, requiredPermission: 'directory_full_access_permission' },
  {
    label: 'Job Seek',
    icon: 'search',
    action: 'toggleJobseekMenu',
    requiredPermission: 'job_seek_modules_permission',
    children: [
      { label: 'Job Listing', route: '/profile/job-listing', class: 'noIconMenu', requiredPermission: 'job_seek_modules_permission' },
      { label: 'Talent Listing', route: '/profile/talent-listing', class: 'noIconMenu', requiredPermission: 'job_seek_modules_permission' },
      { label: 'Talent Enquiries', route: '/profile/talent-enquiries', class: 'noIconMenu', requiredPermission: 'job_seek_modules_permission' },

    ]
  },

  { label: 'My LearningHub', icon: 'grading', route: '/profile/registered-course' },
  // { label: 'Pre-Owned Supplies', class: 'noIconMenu', route: '/profile/pre-owned-supplies' },
  // { label: 'Orders', icon: 'shopping_cart', route: '/profile/orders' },
  // { label: 'My Bids', icon: 'gavel', route: '/profile/my-bids' },


  { label: 'Account Pay Requests', icon: 'payments', route: '/profile/account-pay' },


  { label: 'Support Request', icon: 'support_agent', route: '/profile/support-center' },


  // { label: 'My Enquiries', icon: 'message', route: '/profile/enquiries' },
  { label: 'Subscriptions', route: '/profile/membership', class: 'noIconMenu' },

];
